import script from "./Authentication.vue?vue&type=script&lang=ts&setup=true"
export * from "./Authentication.vue?vue&type=script&lang=ts&setup=true"

import "./Authentication.vue?vue&type=style&index=0&id=970d2cdc&lang=scss"

const __exports__ = script;

export default __exports__